// @core/api/endpoints/webhook/disable_endpoint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DisableEndpointRequest,
  EndpointResponse,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Disable webhook endpoint
 * Temporarily disables a webhook endpoint. Events will be queued but not delivered until the endpoint is re-enabled.
 */
export async function DisableEndpoint(
  endpoint_id: string,
  data: DisableEndpointRequest,
  options?: RequestOptions
): Promise<EndpointResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/endpoints/:endpoint_id/disable`;
  requestPath = requestPath.replace(':endpoint_id', encodeURIComponent(endpoint_id));
  const requestOptions = options;
  return client.post<EndpointResponse>(requestPath, data, requestOptions);
}
